<template>
  <div class="news-detail-content" v-loading="newsloading">
    <guidance path="/aboutNews" :lable="newsDetail.title"></guidance>
    <div class="widthAuto justify-between">
      <div class="content-center">
        <p class="title">{{ newsDetail.title }}</p>
        <div class="justify-between datebox">
          <p class="date">{{ newsDetail.issueTime }}</p>
          <p class="date">
            <i class="el-icon-view"></i> {{ newsDetail.viewCount }}
          </p>
        </div>
        <div class="vhtml" v-html="newsDetail.content"></div>
      </div>
      <div class="content-right">
        <div class="right-box">
          <p class="title text-overflow-ellipsis">相关推荐</p>
          <div class="flex right-content" v-for="item in newsList" :key="item.id" @click="getDetail(item.id)">
            <!-- <div class="align-center datebox">
              <p class="date">{{ getDay(item.issueTime) }}</p>
              <span>{{ getTime(item.issueTime) }}</span>
            </div> -->
            <div class="text">
              <span class="text-overflow-ellipsis-2">{{
                item.title && item.title.length > 32
                ? item.title.substring(0, 32)
                : item.title
              }}
                <span class="tig">{{ getType(item.type) }}</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import guidance from "@/components/guidance.vue";
import {
  getInformationDetail,
  getTopList,
  updateViewCount,
  getDictsByDictCategoryCodeList
} from "@/api/index.js";

export default {
  components: {
    guidance,
  },
  data() {
    return {
      newsloading: false,
      newsDetail: {
        title: null,
      },
      newsList: [],
      TypeList: [],
      id: null,
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getInformationDetail();
    this.getTopList();
    this.getInformationType();
  },
  methods: {
    // 用户访问量加一
    async updateViewCount() {
      let { code, data } = await updateViewCount({
        id: this.id,
      });
      console.log(code, data)
    },
    getDetail(id) {
      this.id = id;
      this.$router.push(`/aboutNewsdetail?id=${id}`)
      this.getInformationDetail();
      this.getTopList();
    },
    getType(type) {
      if (type) {
        let list = this.TypeList.filter((i) => i.code == type);
        return list.length > 0 ? list[0].name : null;
      }
      return null;
    },
    getTime(date) {
      if (date) {
        let timestr = date.split("-");
        return `${timestr[0]}/${timestr[1]}`;
      }
      return;
    },
    getDay(date) {
      if (date) {
        let timestr = date.split(" ")[0];
        return `${timestr.split("-")[2]}`;
      }
      return;
    },
    async getInformationType() {
      let { data } = await getDictsByDictCategoryCodeList({
        fieldCode: "basic",
        dictCategoryCode: "information_type",
      });
      this.TypeList = data.information_type;
    },
    async getTopList() {
      let { data } = await getTopList({
        exclusionId: this.id
      });
      this.newsList = data;
    },
    async getInformationDetail() {
      this.newsloading = true;
      let { code, data } = await getInformationDetail({
        id: this.id,
      });
      if (code === 0) {
        this.newsloading = false;
        let str = data.content;
        str = str.replace(/data-src/g, "referrerpolicy='no-referrer' src");
        data.content = str.replace(/\\/g, "");
        this.newsDetail = data;
        this.updateViewCount();
      } else {
        this.newsloading = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
@width: 1268px;

.news-detail-content {
  padding-bottom: 39px;
  background: #f3f3f4;

  .widthAuto {
    width: @width;
    margin: 0 auto;
  }

  .content-center {
    width: 810px;
    padding: 35px;
    min-height: 700px;
    background: #ffffff;

    .title {
      font-size: 36px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: #000000;
      line-height: 47px;
      word-break: break-all;
    }

    .datebox {
      padding: 17px 0 15px;
      border-bottom: 1px solid #e2e2e2;
      margin-bottom: 27px;

      .date {
        font-size: 16px;
        font-family: MicrosoftYaHei;
        color: #919191;
        line-height: 32px;
      }
    }

    .text {
      font-size: 18px;
      font-family: MicrosoftYaHei;
      color: #000000;
      line-height: 32px;
    }
  }

  .content-right {
    width: 438px;

    .right-box {
      padding: 32px 14px 22px;
      background: #ffffff;

      .title {
        padding-bottom: 20px;
        font-size: 36px;
        font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
        font-weight: bold;
        color: #000000;
        line-height: 47px;
        border-bottom: 1px solid #e2e2e2;
      }

      .datebox {
        color: #999999;
        line-height: 32px;
        padding-right: 20px;

        .date {
          font-size: 48px;
          font-family: ArialNarrow-Bold, ArialNarrow;
          font-weight: bold;
          line-height: 48px;
        }

        span {
          font-size: 14px;
          font-family: ArialNarrow;
        }
      }

      .text {
        font-size: 16px;
        font-family: MicrosoftYaHei;
        color: #000000;
        line-height: 26px;
      }
    }

    .right-content {
      padding: 32px 0 21px;
      border-bottom: 1px solid #e2e2e2;
      cursor: pointer;
    }

    .tig {
      margin-left: 3px;
      padding: 3px 8px 3px;
      display: inline-block;
      height: 24px;
      font-size: 12px;
      line-height: 16px;
      color: #999999;
      background: #ffffff;
      border: 1px solid #dfe1e5;
    }
  }

  .vhtml {
    font-size: 16px !important;
    font-family: MicrosoftYaHei !important;
    color: #333333 !important;
    line-height: 28px !important;
    word-break: break-all;
  }

  p {
    width: auto;
  }
}
</style>
<style>
.content-center pre {
  font-size: 18px;
  font-family: MicrosoftYaHei;
  color: #000000;
  line-height: 32px;
  word-break: break-all;
  white-space: pre-wrap;
}

.content-center img {
  max-width: 100%;
}

.vhtml p,
.vhtml span {
  /* font-size: 16px !important; */
  font-family: MicrosoftYaHei !important;
}

.content-center blockquote {
  background-color: #f5f2f0;
  border-left: 8px solid #b4d5ff;
  display: block;
  font-size: 100%;
  line-height: 1.5;
  margin: 10px 0;
  padding: 10px;
}
</style>
